module.exports = __webpack_public_path__ + "img/logo1.445b2f5f.png";